import { Injectable, Injector } from '@angular/core';
import { Router } from '@angular/router';
import { HttpInterceptor, HttpRequest, HttpHandler } from '@angular/common/http';
import { TokenUtil } from '../_utils/token.util';
import { HttpService } from '../_services/http.service';
import { AuthService } from '../_services/auth.service';
import { getAuth, signOut, onAuthStateChanged } from "firebase/auth";
import {
  Observable,
  throwError,
  throwError as observableThrowError,
  defer,
  from
} from 'rxjs';

import {
  catchError,
  finalize,
  map,
  shareReplay,
  switchMap,
  tap
} from 'rxjs/operators';

@Injectable()
export class CustomHttpInterceptor implements HttpInterceptor {
  private router: Router;
  private http: HttpService;
  private as: AuthService;
  private isTokenLoading = false;


  private tokenRefresh$: Observable<string> | null = null;

  constructor(private injector: Injector) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<any> {
    const token = TokenUtil.get();
    if (TokenUtil.notExpired() && token) {
      return next.handle(
        request.clone({
          setHeaders: {
            Authorization: `Bearer ${token}`
          }
        })
      );
    }
    return this.refreshIdToken().pipe(
      switchMap(token => {
        return next.handle(
          request.clone({
            setHeaders: {
              Authorization: `Bearer ${token}`
            }
          })
        );
      })
    );
  }

  private refreshIdToken(): Observable<string> {
    if (this.tokenRefresh$) {
      return this.tokenRefresh$;
    }

    const user = getAuth().currentUser;

    if (!user) {
      return throwError(() =>
        new Error('User is not signed in.')
      );
    }

    this.tokenRefresh$ = defer(() =>
      from(user.getIdToken(true))
    ).pipe(
      tap(token => {
        TokenUtil.set(token);
      }),
      finalize(() => {
        this.tokenRefresh$ = null;
      }),
      shareReplay(1)
    );

    return this.tokenRefresh$;
  }
}
